module.exports = __webpack_public_path__ + "img/settings.a477dd0f.svg";